import { takeLatest, put, call } from "redux-saga/effects";
import { UnautherizedResponse } from "../GetUser/GetUserActions";
import ACTIONS from "./VisitorLogsActionsTypes";
import { axiosPost, axiosPut, axiosDelete, axiosGet } from "../../Utils/axios";
import {
  deleteVisitorLogResponse,
  getSingleVisitorLogResponse,
  getVisitorLogsResponse,
  postExcelUploadRecordsVisitorLogResponse,
  postExcelUploadVisitorLogResponse,
  postMediaUploadResponse,
  postOTPActionResponse,
  postVistorLogResponse,
  putCheckoutVisitorLogResponse,
  putStatusChangeResponse,
  putVisitorLogReminderResponse,
  putVisitorLogResponse,
} from "./VisitorLogsActions";

export function* onPostVisitorOtpActionHelperSaga({ payload }) {
  try {
    const response = yield call(() =>
      axiosPost("visitor_logs/otp_action", payload).then((res) => res?.data)
    );
    yield put(postOTPActionResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onGetVisitorLogsHelperSaga({ payload }) {
  try {
    const response = yield call(() =>
      axiosPost("visitor_logs/index", payload).then((res) => res?.data)
    );
    yield put(getVisitorLogsResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onPostMediaUploadHelperSaga({ payload }) {
  try {
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    const response = yield call(() =>
      axiosPost("visitor_logs/media", payload, config).then((res) => res?.data)
    );
    yield put(postMediaUploadResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onPostExcelUploadHelperSaga({ payload }) {
  try {
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    const response = yield call(() =>
      axiosPost("visitor_logs/import_excel", payload, config).then(
        (res) => res?.data
      )
    );
    yield put(postExcelUploadVisitorLogResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onPostExcelDataUploadHelperSaga({ payload }) {
  try {
    const response = yield call(() =>
      axiosPost("visitor_logs/import_data", payload).then((res) => res?.data)
    );
    yield put(postExcelUploadRecordsVisitorLogResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onGetSingleVisitorLogHelperSaga({ payload }) {
  try {
    let response = yield call(() =>
      axiosGet(`visitor_logs/${payload._id}`, payload).then((res) => res?.data)
    );
    yield put(getSingleVisitorLogResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onPostVisitorLogHelperSaga({ payload }) {
  try {
    const response = yield call(() =>
      axiosPost("visitor_logs/new", payload).then((res) => res?.data)
    );
    yield put(postVistorLogResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onPutStatusVisitorLogHelperSaga({ payload }) {
  try {
    const response = yield call(() =>
      axiosPut(`visitor_logs/status/${payload?._id}`, payload).then(
        (res) => res?.data
      )
    );
    yield put(putStatusChangeResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onPutVisitorLogHelperSaga({ payload }) {
  try {
    const response = yield call(() =>
      axiosPut(`visitor_logs/${payload?._id}`, payload).then((res) => res?.data)
    );
    yield put(putVisitorLogResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onDeleteVisitorLogHelperSaga({ payload }) {
  try {
    const response = yield call(() =>
      axiosDelete(`visitor_logs/${payload?._id}`, payload).then(
        (res) => res?.data
      )
    );
    yield put(deleteVisitorLogResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onPutReminderNotificationHelperSaga({ payload }) {
  try {
    const response = yield call(() =>
      axiosPut(`visitor_logs/reminder_history/${payload._id}`, payload).then(
        (res) => res?.data
      )
    );
    yield put(putVisitorLogReminderResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onPutVisitorCheckoutProcessHelperSaga({ payload }) {
  try {
    const response = yield call(() =>
      axiosPut(`visitor_logs/process/checkout`, payload).then(
        (res) => res?.data
      )
    );
    yield put(putCheckoutVisitorLogResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* VisitorLogsWatcherSaga() {
  yield takeLatest(
    ACTIONS.POST_OTP_ACTION_REQUEST,
    onPostVisitorOtpActionHelperSaga
  );
  yield takeLatest(
    ACTIONS.POST_MEDIA_UPLOAD_REQUEST,
    onPostMediaUploadHelperSaga
  );
  yield takeLatest(ACTIONS.POST_VISTOR_LOG_REQUEST, onPostVisitorLogHelperSaga);
  yield takeLatest(
    ACTIONS.PUT_STATUS_VISTOR_LOG_REQUEST,
    onPutStatusVisitorLogHelperSaga
  );
  yield takeLatest(ACTIONS.PUT_VISTOR_LOG_REQUEST, onPutVisitorLogHelperSaga);
  yield takeLatest(
    ACTIONS.GET_VISITOR_LOGS_REQUEST,
    onGetVisitorLogsHelperSaga
  );
  yield takeLatest(
    ACTIONS.GET_SINGLE_VISITOR_LOGS_REQUEST,
    onGetSingleVisitorLogHelperSaga
  );
  yield takeLatest(
    ACTIONS.POST_EXCEL_VISITOR_LOG_REQUEST,
    onPostExcelUploadHelperSaga
  );
  yield takeLatest(
    ACTIONS.POST_EXCEL_RECORDS_VISITOR_LOG_REQUEST,
    onPostExcelDataUploadHelperSaga
  );
  yield takeLatest(
    ACTIONS.DELETE_VISITOR_LOG_REQUEST,
    onDeleteVisitorLogHelperSaga
  );
  yield takeLatest(
    ACTIONS.PUT_VISTOR_LOG_REMINDER_REQUEST,
    onPutReminderNotificationHelperSaga
  );
  yield takeLatest(
    ACTIONS.PUT_CHECKOUT_VISTOR_LOG_REQUEST,
    onPutVisitorCheckoutProcessHelperSaga
  );
}
